"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProfiledLayoutType = createProfiledLayoutType;
var Profiler_1 = require("icf-search-client-shared/lib/Profiler");
function createProfiledLayoutType(layoutType, name) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.getItemSize = function (context) {
            var _this = this;
            return Profiler_1.profiler.measure(function () {
                return _super.prototype.getItemSize.call(_this, context);
            }, "".concat(name, ".getItemSize"));
        };
        class_1.prototype.getFullContentSize = function (context) {
            var _this = this;
            return Profiler_1.profiler.measure(function () {
                return _super.prototype.getFullContentSize.call(_this, context);
            }, "".concat(name, ".getFullContentSize"));
        };
        class_1.prototype.getItemRectAtIndex = function (context, itemIndex, item) {
            var _this = this;
            return Profiler_1.profiler.measure(function () {
                return _super.prototype.getItemRectAtIndex.call(_this, context, itemIndex, item);
            }, "".concat(name, ".getItemRectAtIndex"));
        };
        class_1.prototype.getItemRangeForRect = function (context, rect) {
            var _this = this;
            return Profiler_1.profiler.measure(function () {
                return _super.prototype.getItemRangeForRect.call(_this, context, rect);
            }, "".concat(name, ".getItemRangeForRect"));
        };
        return class_1;
    }(layoutType));
}
//# sourceMappingURL=ProfilingWrappedLayout.js.map